<template>
  <div class="switch-item">
    <div v-if="!disabled">
      <md-button
        class="item-button full-width"
        :class="{ selected }"
        :disabled="disabled"             
        v-bind="$attrs"
        @click="click"
        @mouseover="mouseOver"
        @mouseleave="mouseLeave"
      >
        <span :class="{ selected }">
          {{ label }}
        </span>
        <md-icon v-if="showCaret" class="icon">arrow_forward_ios</md-icon>
        <help-tooltip v-if="warning" type="warning" class="warning-tooltip" />
        <help-tooltip v-if="error" type="error" class="warning-tooltip" />
        <md-icon v-if="hasChildren && !isExpanded">expand_more</md-icon>
        <md-icon v-if="hasChildren && isExpanded">expand_less</md-icon>
      </md-button>
      <md-tooltip v-if="tooltip">
        {{ tooltip }}
      </md-tooltip>
    </div>
    <div 
      v-else
      class="item-text"
      :class="{ disabled, error }"
    >
      <span 
        :class="{ disabled, error }"
        @mouseover="mouseOver"
        @mouseleave="mouseLeave"
      >
        {{ label }}
        <help-tooltip v-if="tooltip" type="info" size="small">
          {{ tooltip }}
        </help-tooltip>
      </span>
      <md-icon v-if="showCaret" class="icon disabled">arrow_forward_ios</md-icon>
    </div>
  </div>
</template>

<script>
import HelpTooltip from '~lib/common/components/HelpTooltip.vue';

export default {
  name: 'switch-item',
  components: {
    HelpTooltip,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    warning: {
      type: Boolean,
      default: false,
    },
    showCaret: {
      type: Boolean,
      default: false,
    },
    hasChildren: {
      type: Boolean,
      default: false,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: null,
    },
  },
  methods: {
    click(...args) {
      this.$emit('click', ...args);
    },
    mouseOver() {
      this.$emit('mouseOver');
    },
    mouseLeave() {
      this.$emit('mouseLeave');
    },
  },
};
</script>

<style scoped>
.item-button,
.item-text {
  height: 3rem;
  border-radius: 0;
  margin: 0;
  white-space: initial;
  text-align: left;
}

.item-button {
  width: 100%;
}

.item-text {
  padding-left: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;  
}

.md-button span.selected {
  color: #5595ff;
}

.md-button >>> .md-ripple {
  padding-right: 0;
}

.md-button >>> .md-button-content {
  width: 100%;
  display: flex;
  align-items: center;
  font-weight: normal;
  justify-content: space-between;
}

.span {
  display: inline-block;
}

span.disabled, span.error {
  color: var(--md-theme-default-disabled-on-background, rgba(0,0,0,0.26));
}

.md-icon {
  margin: 0;
}

.md-icon.disabled {
  color: var(--md-theme-default-disabled-on-background, rgba(0,0,0,0.26));
}

.help-tooltip {
  margin-left: 4px;
}

.warning-tooltip {
  margin-right: 4px;
}
</style>